import { createFileRoute } from "@tanstack/react-router"

import { TripDetail } from "@/trips/components/trips/trip-detail"

export const Route = createFileRoute("/_app-shell/trips/$id")({
  head: () => ({ meta: [{ title: "Trip - Kestly" }] }),
  component: function TripRoute() {
    const { id } = Route.useParams()
    return <TripDetail id={id} />
  },
})
